<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </template>
        <span>View Separation History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="green"
      title="Separation History"
      text="Employee Separation History"
      class="mb-0"
    > 
      <template v-if="!loading">
        <v-timeline    
          v-if="separations.length > 0"      
          dense
        >
          <v-timeline-item
            v-for="(item, i) in separations"        
            :key="i"
            color="error"
            right
            small
          >
            <v-card>
              <v-list
                two-line
                color="error"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold text-capitalize white--text text-uppercase">
                      {{ item.type.name }}
                    </v-list-item-title>
                    <v-list-item-title>
                      <span class="font-weight-light white--text">Resigned Effective Date:</span>
                      <span class="white--text">{{ $moment(item.effective_date, 'YYYY-MM-DD').format('DD MMM YYYY') }} </span>
                    </v-list-item-title>
                    <v-list-item-title>
                      <span class="font-weight-light white--text"> Last Working Day:</span>
                      <span class="white--text">{{ item.last_working_date? $moment(item.last_working_date, 'YYYY-MM-DD').format('DD MMM YYYY'):'N/A' }} </span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-uppercase pt-1 white--text">
                      by {{ item.created_by }} 
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action v-if="$hasPermissionTo(['update employment section'])">
                    <v-menu
                      bottom
                      right
                      nudge-right="30px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          text
                          icon
                          color="white"
                          v-on="on"                        
                        >
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                  
                      <v-list>
                        <v-list-item         
                          @click="$refs.editDialog.toggleDialog(item)"
                        >
                          <v-list-item-title>                             
                            Edit
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item         
                          @click="$refs.uploadDialog.toggleDialog(item)"
                        >
                          <v-list-item-title>                             
                            Add File
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>                    
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-card-text
                class="white text--primary text-justify"
                style="white-space: pre-line;"
              >
                {{ item.reason }}
              </v-card-text>

              <div v-if="item.documents.length > 0">
                <v-divider />

                <v-card-subtitle class="font-weight-bold white black--text pb-0">
                  {{ item.documents.length }} documents
                </v-card-subtitle>
              </div>

              <v-container class="white py-0 px-4">
                <v-row>
                  <template v-for="document in item.documents">
                    <v-col 
                      :key="document.id"
                      cols="6"
                      md="4"
                      class="px-1 py-2"
                    >
                      <v-chip
                        color="blue-grey lighten-3"
                        link
                        style="width: 100%;"
                        :href="document.file_url"
                        target="_blank"
                      >
                        <v-icon
                          color="red"
                          left
                        >
                          mdi-file-pdf
                        </v-icon>
                        <span class="text-truncate"> {{ document.file_name }} </span>
                      </v-chip>
                    </v-col>
                  </template> 
                </v-row>
              </v-container>
            </v-card>
          </v-timeline-item>
        </v-timeline>
        <v-container
          v-else 
          class="pa-6"
        >
          <v-row 
            align="center"
            justify="center"
          >
            <span> No data available</span>
          </v-row>
        </v-container>
      </template>
      <employee-separations-dialog-edit
        ref="editDialog"
        :employee-uid="employeeUid"
        @updated="loadData"
      />
      <employee-separations-dialog-upload
        ref="uploadDialog"
        :employee-uid="employeeUid"
        @uploaded="loadData"
      />
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      EmployeeSeparationsDialogEdit: () => import('@/components/employee/separations/DialogEdit'),
      EmployeeSeparationsDialogUpload: () => import('@/components/employee/separations/DialogUpload'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },    
    },
    data () {
      return {
        dialog: false,
        loading: false,
        separations: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadData()
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.employeeSeparations().list(this.employeeUid)
          .then(response => {
            this.separations = response.data

            this.loading = false
          })
      },
      openDialog () {
        this.dialog = true
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    height:45vh;
  }
</style>
